export default {
  cube: require('./cube').default,
};
